import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ 
  children, 
  adminOnly = false, 
  preventIfAuthenticated = false,
  requireAuth = true // Nuevo prop para rutas que requieren autenticación
}) => {
  const { 
    isAuthenticated,
    usuario: { rol } = {} // Valor por defecto para evitar errores si usuario no está definido
  } = useSelector((state) => state.auth);
  
  const location = useLocation();

  // Redirigir si está autenticado y la ruta es para no autenticados (como login)
  if (preventIfAuthenticated && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Redirigir si no está autenticado y la ruta requiere autenticación
  if (requireAuth && !isAuthenticated && !preventIfAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si la ruta es solo para admin y el usuario no es admin
  if (adminOnly && rol !== 'administrador') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;